import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CodeNamePair } from '../../model/code-name-pair.model';
import { SearchFilterService } from '../services/search-filter.service';

@Injectable()
export class LossStatusesResolver implements Resolve<CodeNamePair[]> {
  constructor (
    private searchFilterService: SearchFilterService,
    private router: Router
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CodeNamePair[]> {
    return this.searchFilterService.getLossStatuses().map(lossStatuses => {
      if (lossStatuses) {
        return lossStatuses;
      } else {
        this.router.navigate(['/']);
        return null;
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/resolvers/loss-statuses.resolver.ts